import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import ficRatings from "../../../../src/data/articles/cube-prospective-final-fantasy-commander/fic-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  ficRatings,
  ProspectiveIntro,
  React
};